import { useEffect, useState } from "react";
import api, { fmtUSD, fmtQty, fmtPct } from "@/lib/api";
import { Panel, Table, Money, Pct, Empty } from "@/components/terminal";

export default function Portfolio() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/positions").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="text-slate-500 font-mono text-sm">Loading…</div>;
  return (
    <div className="space-y-5" data-testid="portfolio-page">
      <h2 className="font-display text-xl font-bold">Portfolio Positions</h2>
      <Panel title="Holdings (derived from open tax lots)" testId="portfolio-holdings">
        {data.positions.length === 0 ? <Empty>No open positions. Deploy capital to establish holdings.</Empty> : (
          <Table testId="portfolio-table" head={[{ label: "Asset" }, { label: "Quantity", num: true }, { label: "Price", num: true }, { label: "Value", num: true }, { label: "Cost Basis", num: true }, { label: "Unrealized P/L", num: true }, { label: "Weight", num: true }]}>
            {data.positions.map((p) => (
              <tr key={p.asset} className="hover:bg-[#222630]" data-testid={`position-row-${p.asset}`}>
                <td className="td-cell font-semibold text-slate-100">{p.asset}</td>
                <td className="td-num">{fmtQty(p.quantity)}</td>
                <td className="td-num">{fmtUSD(p.price)}</td>
                <td className="td-num">{fmtUSD(p.value)}</td>
                <td className="td-num">{fmtUSD(p.cost_basis)}</td>
                <td className="td-num"><Money value={p.unrealized_pl} tone={p.unrealized_pl >= 0 ? "pos" : "neg"} /></td>
                <td className="td-num"><Pct value={(data.weights[p.asset] || 0) * 100} /></td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
    </div>
  );
}
